// extracted by mini-css-extract-plugin
module.exports = {"form-control":"CustomInput_form-control__3dgR1","form-control--invalid":"CustomInput_form-control--invalid__1dHxC"};